import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { BankAccountDTO, BankFeatures, BankProvider } from '@/types/bank';
import { BANK_FEATURES } from '@/types/bank';

/**
 * Conta bancária selecionada (empresa · banco). Persistido (whitelist em store/index.ts).
 * O ApiService lê `selected.id` para mandar o header X-Bank-Account-Id.
 */
export interface BankAccountState {
  accounts: BankAccountDTO[];
  selected: BankAccountDTO | null;
  loaded: boolean;
}

const initialState: BankAccountState = {
  accounts: [],
  selected: null,
  loaded: false,
};

const bankAccountSlice = createSlice({
  name: 'bankAccount',
  initialState,
  reducers: {
    setAccounts: (state, action: PayloadAction<BankAccountDTO[]>) => {
      state.accounts = action.payload;
      state.loaded = true;
      // Mantém a seleção se ainda existir; senão limpa
      if (state.selected && !action.payload.some(a => a.id === state.selected!.id)) {
        state.selected = null;
      }
    },
    selectAccount: (state, action: PayloadAction<BankAccountDTO | null>) => {
      state.selected = action.payload;
    },
    clearBankAccount: () => initialState,
  },
});

export const { setAccounts, selectAccount, clearBankAccount } = bankAccountSlice.actions;
export default bankAccountSlice.reducer;

// Selectors
type RootLike = { bankAccount?: BankAccountState };
export const selectBankAccounts = (state: RootLike) => state.bankAccount?.accounts ?? [];
export const selectBankAccount = (state: RootLike) => state.bankAccount?.selected ?? null;
export const selectBankProvider = (state: RootLike): BankProvider | null => state.bankAccount?.selected?.provider ?? null;
export const selectBankFeatures = (state: RootLike): BankFeatures => {
  const p = state.bankAccount?.selected?.provider;
  // Sem conta selecionada: comportamento histórico (Sicoob) para não esconder o menu
  return BANK_FEATURES[p ?? 'sicoob'];
};
